import { Objects } from '../object-definitions'

export namespace SimpleEditorConfiguration {
    export function sanitizeListingOptions(simpleEditorConfiguration: Objects.SimpleEditorConfiguration) {
        for (const section of simpleEditorConfiguration.sections) {
            for (const field of section.fields) {
                if (field.listingOptions) {
                    if (field.listingOptions.type === 'image') {
                        if (!field.listingOptions.isEnabled) {
                            field.listingOptions = undefined
                        }
                    } else {
                        if (!field.listingOptions.key) {
                            field.listingOptions = undefined
                        }
                    }
                } else {
                    if (field.listingOptions !== undefined) {
                        field.listingOptions = undefined
                    }
                }
            }
        }
    }
}
